import { createContext } from "react";
const IconContext = createContext({
  color: "black",
  size: 24,
  weight: "regular"
});
const IconContextProvider = IconContext.Provider;
export {
  IconContext,
  IconContextProvider
};
//# sourceMappingURL=IconContextProvider.js.map
